import axiosInstance from "../../translator";
import { usage as usageEndpoints } from "../../constants/apis/apiEndpoints";

export const fetchUsageSummaryData = async (data) => {
  const usageSummaryData = axiosInstance
    .post(`${usageEndpoints?.usageEndpoint}${data?.tenantId}`, data?.formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return usageSummaryData;
};

export const generateReport = async (data) => {
  const generateInfo = axiosInstance
    .post(usageEndpoints?.usageReport, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return generateInfo;
};

export const fetchReportListData = async (urlParams) => {
  return axiosInstance
    .get(`${usageEndpoints?.usageReport}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getUsageReportSkuApi = async (urlParams) => {
  return axiosInstance
    .get(`${usageEndpoints?.usageReportSkuEndpoint}${urlParams.params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getUsageReportUsersApi = async (urlParams) => {
  return axiosInstance
    .get(`${usageEndpoints?.usageUserList}${urlParams.params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const generatePublicReport = async (data) => {
  const generateInfo = axiosInstance
    .post(usageEndpoints?.publicUsageReport, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return generateInfo;
};

export const fetchPublicReportListData = async (urlParams) => {
  return axiosInstance
    .get(`${usageEndpoints?.publicUsageReport}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};